export enum UmpireComponentTypeEnum {
  ADVERTISEMENT = 'advertisement',
  COMPETITION_SEASON_STATISTICS = 'competition_season_statistics',
  CLUB = 'club',
  GALLERY = 'gallery',
  PAGE_HEADER = 'page_header',
  HERO_MAIN = 'hero_main',
  HERO_THEMATIC = 'hero_thematic',
  ROUND = 'round',
  GROUP = 'group',
  SCHEDULE = 'schedule',
  SOCIAL_MEDIA = 'social_media',
  QUIZ = 'quiz',
  MATCH = 'match',
  IFRAME = 'iframe',
  IMAGE = 'image',
  NEWS = 'news',
  QUOTATION = 'quotation',
  TEXT = 'text',
  OTT_FORMAT = 'ott_format',
  OTT_FORMAT_LIST = 'ott_format_list',
  OTT_PLAYLIST = 'ott_playlist',
  OTT_PLAYLIST_LIST = 'ott_playlist_list',
  OTT_HERO_MAIN = 'ott_hero_main',
  OTT_EXTERNAL_CONTENT = 'ott_external_content',
  CLUB_LIST = 'club_list',
  MATCH_LIST = 'match_list',
  SURVEY = 'survey',
  PRODUCT_LIST = 'product_list',
  EVENTS = 'events',
  SQUAD = 'squad',
  VIDEO = 'video',
  PAGE_FOOTER = 'page_footer',
  BRANDING = 'branding',
  MATCH_PREDICTOR_RANKING = 'match_predictor_ranking',
  FAQ = 'faq',
  CONTACT = 'contact',
}
